<template>
<div class="chapter">
<div class="inner_page">
<p class="fm1t"><a id="page_iii"></a>And hence one master passion in the breast,</p>
<p class="fm1">Like Aaron’s serpent, swallows up the rest.</p>
<p class="fm2">—<span class="smallcaps">ALEXANDER POPE</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Fm01.vue?0871e22d